// extracted by mini-css-extract-plugin
module.exports = {"small":"styles-module--small--1s7r7","medium":"styles-module--medium--1I2w7","tilted":"styles-module--tilted--2QOt_"};